/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
    mutation CustomerInvoiceDeleteMutation($customerInvoiceId: ID!) {
      CustomerInvoiceDelete(customerInvoiceId: $customerInvoiceId) {
        status,
        message
    }
  }
`
